import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from "./components/Navbar";
import WelcomeBanner from "./components/WelcomeBanner";
import Login from "./pages/Login";
import ChangePasswordModal from "./components/ChangePasswordModal";
import { useAuth } from "./hooks/useAuth";
import { appRoutes } from "./navigation";
import { canAccessNavigationItem } from "./auth/roles";

console.log("APP VERSION 2026-03-19-3");

function PrivateRoute({ user, children }) {
  const { pathname, search, hash } = useLocation();
  if (!user) {
    return <Navigate to="/" replace state={{ from: { pathname, search, hash } }} />;
  }
  return children;
}

function AppContent() {
  const { user, loading, login, logout, checkAuth } = useAuth();
  const location = useLocation();
  const [showChangePassword, setShowChangePassword] = React.useState(false);
  const returnLocation = location.state?.from;
  const returnRoute = appRoutes.find((route) => route.path === returnLocation?.pathname);
  const loginDestination = returnRoute && canAccessNavigationItem(user, returnRoute)
    ? { pathname: returnRoute.path, search: returnLocation.search, hash: returnLocation.hash }
    : "/home";

  if (loading) {
    return <div className="container mt-5">Loading...</div>;
  }

  return (
    <>

      <Navbar
        user={user}
        onLogout={logout}
        checkAuth={checkAuth}
        onChangePassword={() => setShowChangePassword(true)}
      />
      <WelcomeBanner user={user} />

      <Routes>
        {/* Login */}
        <Route
          path="/"
          element={!user ? <Login onLogin={login} /> : <Navigate to={loginDestination} replace />}
        />

        {appRoutes.map((route) => {
          const Page = route.component;
          const routeElement = canAccessNavigationItem(user, route)
            ? <Page {...(route.props ?? {})} {...(route.passUser ? { user } : {})} />
            : <Navigate to="/home" />;

          return (
            <Route
              key={route.path}
              path={route.path}
              element={
                <PrivateRoute user={user}>
                  {routeElement}
                </PrivateRoute>
              }
            />
          );
        })}

        {/* fallback */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>

      {user && (
        <ChangePasswordModal
          show={showChangePassword || Boolean(user.mustChangePassword)}
          force={Boolean(user.mustChangePassword)}
          user={user}
          onClose={() => setShowChangePassword(false)}
          onLogout={logout}
          onChanged={async () => {
            setShowChangePassword(false);
            await checkAuth();
          }}
        />
      )}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
